import { CoreState } from "../../state";

import { SessionSummary } from "./session-summary.model";

/**
 * @deprecated [fabric-deprecated] - Use SessionSummaryService from app-responsible-gaming instead
 */
export namespace SessionSummarySelector {
	/**
	 * @deprecated [fabric-deprecated] - Use ResponsibleGamingAppCommand.GetSessionSummary instead
	 */
	export const get = (state: CoreState): SessionSummary | undefined => state.sessionSummary.sessionSummary;
}
